import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-cream-200 last:border-b-0" data-id="element-52">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left group" aria-expanded={isOpen} data-id="element-53">
        <span className="font-heading text-lg font-semibold text-navy-900 pr-4 group-hover:text-gold-600 transition-colors" data-id="element-54">
          {question}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="flex-shrink-0" data-id="element-55">
          <ChevronDownIcon className="w-5 h-5 text-gold-500" aria-hidden="true" data-id="element-56" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-57">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-58">
            <p className="font-body text-gray-600 leading-relaxed pb-5" data-id="element-59">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-60px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-cream-100 py-16 md:py-24" ref={ref} data-id="element-60">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-62">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-navy-900 mb-4" data-id="element-63">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 h-1 bg-gold-500 mx-auto" data-id="element-64" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.5,
        delay: 0.15
      }} className="bg-white rounded-xl border border-cream-200 px-6 sm:px-8" data-id="element-65">
          <FAQItem question="¿Necesito el SSN para empezar el plan?" answer="No, el protocolo te enseña qué hacer mientras esperas que llegue tu número. Hay trámites que puedes y debes adelantar sin él." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-66" />
          <FAQItem question="¿Sirve para cualquier estado?" answer="Sí, los fundamentos bancarios y de vivienda aplican a nivel nacional en EE.UU. Las variaciones estatales están señaladas dentro del protocolo." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-67" />
          <FAQItem question="¿El pago es único?" answer="Sí, un solo pago y recibes todas las actualizaciones futuras del protocolo. Sin suscripciones ni cargos recurrentes." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-68" />
          <FAQItem question="¿Puedo usarlo si viajo solo?" answer="Totalmente. Aunque está optimizado para familias, es igual de efectivo para individuos. Los trámites y la secuencia son los mismos." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-69" />
        </motion.div>
      </div>
    </section>;
}